var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detect-step"},[_c('div',{staticClass:"detect-step-icon",class:{
      success: _vm.status === 'success',
      fail: _vm.status === 'fail'
    }}),_c('p',{staticClass:"detect-step-text",class:{
    'detect-step-text__inactive': !_vm.isActived,
    'fail-text': _vm.status === 'fail'
  }},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }